import * as React from "react";
import { TouchableOpacity, View, Text, StyleSheet } from "react-native";
import { currentLanguage } from "../../translations/CurrentLanguage";

import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors, formatMoney } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

const TONES = {
  completed: { color: colors.success, background: "#ecfdf3" },
  cancelled: { color: colors.danger, background: colors.dangerSoft },
};

const ReceiptCardComponent = props => {
  strings.setLanguage(currentLanguage().companyLanguage);
  const status = String(props.status || "");
  const tone = TONES[status.toLowerCase()] || {
    color: colors.primary,
    background: colors.primarySoft,
  };

  return (
    <TouchableOpacity
      activeOpacity={0.7}
      style={styles.row}
      onPress={() => props.onPress(props.obj)}
    >
      <View style={styles.icon}>
        <Icon name="receipt" size={20} color={colors.primary} />
      </View>
      <View style={styles.main}>
        <Text style={styles.title}>
          {`${strings.Receipt} #${props.number}`}
        </Text>
        <View style={styles.meta}>
          <View style={[styles.badge, { backgroundColor: tone.background }]}>
            <Text style={[styles.badgeText, { color: tone.color }]}>
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </Text>
          </View>
          {props.role === "Owner" ? (
            <Text style={styles.muted}>
              {strings.Attendant}: {props.obj.attendant}
            </Text>
          ) : null}
        </View>
      </View>
      <View style={styles.right}>
        <Text style={styles.amount}>
          {formatMoney(props.amount, props.currency, props.isCurrencyDisabled)}
        </Text>
        <Text style={styles.muted}>{props.date.toLocaleDateString()}</Text>
      </View>
      <Icon name="chevron-right" size={22} color={colors.textFaint} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 14,
    paddingLeft: 18,
    paddingRight: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#eef2f7",
  },
  icon: {
    width: 42,
    height: 42,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.primarySoft,
  },
  main: {
    flex: 1,
    marginLeft: 14,
  },
  title: {
    fontSize: 16,
    fontWeight: "700",
    color: colors.text,
  },
  meta: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 5,
  },
  badge: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    marginRight: 10,
    borderRadius: 999,
  },
  badgeText: {
    fontSize: 12,
    fontWeight: "700",
  },
  muted: {
    fontSize: 13,
    color: colors.textMuted,
  },
  right: {
    alignItems: "flex-end",
    marginRight: 8,
  },
  amount: {
    marginBottom: 3,
    fontSize: 16,
    fontWeight: "700",
    color: colors.text,
  },
});

export default ReceiptCardComponent;
